/* Mulberry House — cart sale display. Shows the old price struck through beside the
   sale price on every cart line, plus the total saved and the close. Reads compare-at
   from the live product data; changes nothing about what the cart charges. */
(function(){
var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/',CUR=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR',cache={},t=null;
function money(c){c=c||0;var f=c%100?2:0;try{return new Intl.NumberFormat('en-IE',{style:'currency',currency:CUR,minimumFractionDigits:f,maximumFractionDigits:f}).format(c/100);}catch(e){return '€'+(c/100).toFixed(f);}}
function prod(h){if(!cache[h])cache[h]=fetch(R+'products/'+h+'.js').then(function(r){if(!r.ok)throw 0;return r.json();});return cache[h];}
function lastPrice(td){var a=[].slice.call(td.querySelectorAll('.price--end')).filter(function(e){return e.tagName!=='S';});return a[a.length-1]||null;}
function row(tr){
if(tr.getAttribute('data-mh-cart'))return Promise.resolve(0);
var q=tr.querySelector('input.quantity__input'),a=tr.querySelector('a.cart-item__name')||tr.querySelector('a.cart-item__link');
if(!q||!a)return Promise.resolve(0);
var vid=q.getAttribute('data-quantity-variant-id'),qty=parseInt(q.value,10)||1;
var m=(a.getAttribute('href')||'').match(/\/products\/([^?#\/]+)/);
if(!vid||!m)return Promise.resolve(0);
tr.setAttribute('data-mh-cart','1');
return prod(m[1]).then(function(p){
var v=(p.variants||[]).filter(function(x){return String(x.id)===String(vid);})[0];
if(!v||!v.compare_at_price||v.compare_at_price<=v.price)return 0;
var pc=tr.querySelector('td.cart-item__details>.product-option')||tr.querySelector('td.cart-item__details .cart-item__discounted-prices');
if(pc)pc.innerHTML='<s class="mh-cart-old">'+money(v.compare_at_price)+'</s> <strong class="mh-cart-now">'+money(v.price)+'</strong> <b class="mh-cart-off">−'+Math.round((1-v.price/v.compare_at_price)*100)+'%</b>';
[].slice.call(tr.querySelectorAll('td.cart-item__totals')).forEach(function(td){
var el=lastPrice(td);if(el)el.innerHTML=money(v.price*qty)+' <s class="mh-cart-old">'+money(v.compare_at_price*qty)+'</s>';});
return (v.compare_at_price-v.price)*qty;
}).catch(function(){return 0;});
}
function close(saved,scope){
if(!scope)return;
var cta=scope.querySelector('.cart__ctas');if(!cta||cta.getAttribute('data-mh-cart'))return;
cta.setAttribute('data-mh-cart','1');
if(saved<=0)return;
var d=document.createElement('div');d.className='mh-cart-save';
d.innerHTML='<p class="h">You are saving '+money(saved)+' on this order.</p><p class="b">The sale price is already in every line above — there is no code to enter. Sale prices hold until Wednesday 11 November. Made to order, around four weeks, and we confirm your delivery date before you pay.</p>';
cta.parentNode.insertBefore(d,cta);
}
function paint(){
['#main-cart-items','#CartDrawer-CartItems'].forEach(function(sel){
var sc=document.querySelector(sel);if(!sc)return;
var rows=[].slice.call(sc.querySelectorAll('tr.cart-item'));if(!rows.length)return;
var drawer=sc.closest?sc.closest('cart-drawer'):null;
Promise.all(rows.map(row)).then(function(a){
var s=a.reduce(function(x,y){return x+(y||0);},0);
if(s<=0)return;
close(s,document.querySelector('#main-cart-footer'));
if(drawer)close(s,drawer);
});});}
function go(){clearTimeout(t);t=setTimeout(paint,250);}
var css='.mh-cart-old{color:#7c6b72;text-decoration:line-through;font-weight:400;margin-left:6px}'+
'.mh-cart-now{color:#26141d;font-weight:600}'+
'.mh-cart-off{display:inline-block;font-size:11px;font-weight:600;letter-spacing:.04em;color:#571f32;background:#e9d6b8;border-radius:2px;padding:2px 6px;margin-left:6px}'+
'.mh-cart-save{border:1px solid #e9d6b8;border-left:3px solid #ac8a55;border-radius:2px;padding:14px 16px;margin:0 0 16px;background:#fffdf9}'+
'.mh-cart-save .h{font-family:Fraunces,Georgia,serif;font-size:20px;line-height:1.2;color:#571f32;margin:0 0 6px}'+
'.mh-cart-save .b{font-size:14px;line-height:1.5;color:#26141d;margin:0}';
var st=document.createElement('style');st.id='mh-cart-css';st.textContent=css;document.head.appendChild(st);
if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
window.addEventListener('load',go);
new MutationObserver(go).observe(document.body||document.documentElement,{childList:true,subtree:true});
})();
